module.exports = __webpack_public_path__ + "img/device-10.0fef4455.png";